<ng-container rtBlock="sc-home-page">
    <sc-home-hero qa-dataid="home-hero" />

    <section rtElem="types">
        <div rtElem="types-head">
            <h2 rtElem="types-h2">
                <!-- A real space, not a margin: without it the two words form one unbreakable run wider than a phone screen. -->
                <em i18n="@@homeTypesHeadEm">Четыре</em>
                &ngsp;
                <span i18n="@@homeTypesHeadRest">геометрии, одна доменная логика.</span>
            </h2>
            <div rtElem="types-note" i18n="@@homeTypesNote">
                Выберите тип — получите посадочную страницу с преднастроенным конструктором и нормативным контекстом.
            </div>
        </div>
        <div rtElem="grid-4">
            <sc-home-type-card
                link="/calc/straight"
                num="01 · прямая"
                i18n-num="@@homeTypeNumStraight"
                specs="single flight · 14 ст."
                i18n-specs="@@homeTypeSpecsStraight"
                proj="side · 1:50"
                i18n-proj="@@homeTypeProjStraight"
                axis="y↑ x→"
                i18n-axis="@@homeTypeAxisSide"
                caption="Прямая"
                i18n-caption="@@homeTypeTitleStraight"
                desc="Один марш без поворотов. Самая простая геометрия и самая дешёвая в изготовлении. Требует прямого проёма длиной от 3 м."
                i18n-desc="@@homeTypeDescStraight">
                <svg rtElem="sketch-svg" viewBox="0 0 280 224" preserveAspectRatio="xMidYMid meet">
                    <defs>
                        <pattern id="hatch1" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                            <line x1="0" y1="0" x2="0" y2="4" stroke="currentColor" stroke-width=".4" />
                        </pattern>
                    </defs>
                    <rect x="14" y="40" width="78" height="6" fill="url(#hatch1)" stroke="currentColor" stroke-width=".6" />
                    <rect x="14" y="40" width="78" height="6" fill="none" stroke="currentColor" stroke-width=".8" />
                    <rect x="14" y="180" width="252" height="6" fill="url(#hatch1)" stroke="currentColor" stroke-width=".6" />
                    <rect x="14" y="180" width="252" height="6" fill="none" stroke="currentColor" stroke-width=".8" />
                    <line x1="92" y1="40" x2="266" y2="40" stroke="currentColor" stroke-width=".5" stroke-dasharray="2 3" />
                    <path
                        d="M100 180 L240 46 L240 60 L114 180 Z"
                        fill="currentColor"
                        fill-opacity=".06"
                        stroke="currentColor"
                        stroke-width=".8" />
                    <g stroke="currentColor" stroke-width=".8" fill="none">
                        <path
                            d="M100 180 L100 170 L111 170 L111 160 L122 160 L122 150 L133 150 L133 140 L144 140 L144 130 L155 130 L155 120 L166 120 L166 110 L177 110 L177 100 L188 100 L188 90 L199 90 L199 80 L210 80 L210 70 L221 70 L221 60 L232 60 L232 50 L243 50" />
                    </g>
                    <line x1="106" y1="160" x2="246" y2="26" stroke="currentColor" stroke-width=".7" />
                    <g stroke="currentColor" stroke-width=".4">
                        <line x1="115" y1="170" x2="119" y2="151" />
                        <line x1="137" y1="150" x2="141" y2="129" />
                        <line x1="159" y1="130" x2="163" y2="107" />
                        <line x1="181" y1="110" x2="185" y2="85" />
                        <line x1="203" y1="90" x2="207" y2="63" />
                        <line x1="225" y1="70" x2="229" y2="41" />
                    </g>
                    <line x1="100" y1="180" x2="100" y2="158" stroke="currentColor" stroke-width="1.2" />
                    <line x1="243" y1="50" x2="243" y2="22" stroke="currentColor" stroke-width="1.2" />
                    <g rtElem="dim" font-family="JetBrains Mono" font-size="7">
                        <line x1="6" y1="46" x2="6" y2="180" />
                        <line x1="3" y1="46" x2="9" y2="46" />
                        <line x1="3" y1="180" x2="9" y2="180" />
                        <text x="0" y="116" transform="rotate(-90 0 116)" text-anchor="middle">2 800</text>
                    </g>
                    <g rtElem="dim" font-family="JetBrains Mono" font-size="7">
                        <line x1="100" y1="200" x2="243" y2="200" />
                        <line x1="100" y1="197" x2="100" y2="203" />
                        <line x1="243" y1="197" x2="243" y2="203" />
                        <text x="171" y="210" text-anchor="middle" i18n="@@homeTypeDimRunStraight">3 500 мм</text>
                    </g>
                    <g stroke="currentColor" stroke-width=".5" fill="none">
                        <path d="M126 180 A26 26 0 0 0 100 154" />
                    </g>
                    <text x="118" y="174" font-family="JetBrains Mono" font-size="6" fill="currentColor">38°</text>
                </svg>
                <ng-container meta-rows>
                    <div>
                        <span i18n="@@homeTypeMetaSteps">ступеней</span>
                        <b>14</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaRise">подъём</span>
                        <b>200</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaTread">проступь</span>
                        <b>250</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaAngle">угол</span>
                        <b>38.6°</b>
                    </div>
                </ng-container>
            </sc-home-type-card>

            <sc-home-type-card
                link="/calc/l"
                num="02 · г-образная"
                i18n-num="@@homeTypeNumL"
                specs="2 марша · площадка"
                i18n-specs="@@homeTypeSpecsL"
                proj="plan · 1:50"
                i18n-proj="@@homeTypeProjPlan50"
                axis="план · вид сверху"
                i18n-axis="@@homeTypeAxisPlan"
                caption="Г-образная"
                i18n-caption="@@homeTypeTitleL"
                desc="Поворот на 90° через площадку или забежные. Экономит линейную длину, удобно вписывать в угол комнаты."
                i18n-desc="@@homeTypeDescL">
                <svg rtElem="sketch-svg" viewBox="0 0 280 224" preserveAspectRatio="xMidYMid meet">
                    <defs>
                        <pattern id="hatch2" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                            <line x1="0" y1="0" x2="0" y2="4" stroke="currentColor" stroke-width=".3" />
                        </pattern>
                    </defs>
                    <rect x="20" y="20" width="240" height="180" fill="none" stroke="currentColor" stroke-width="1.4" />
                    <rect
                        x="24"
                        y="24"
                        width="232"
                        height="172"
                        fill="none"
                        stroke="currentColor"
                        stroke-width=".3"
                        stroke-dasharray="1 2" />
                    <rect x="30" y="30" width="60" height="60" fill="url(#hatch2)" stroke="currentColor" stroke-width=".8" />
                    <text
                        x="60"
                        y="64"
                        font-family="JetBrains Mono"
                        font-size="7"
                        text-anchor="middle"
                        fill="currentColor"
                        i18n="@@homeTypeLandingLabel">
                        площадка
                    </text>
                    <text x="60" y="74" rtElem="dim-text" font-family="JetBrains Mono" font-size="6" text-anchor="middle">900×900</text>
                    <g stroke="currentColor" stroke-width=".7" fill="none">
                        <rect x="30" y="90" width="60" height="100" />
                        <line x1="30" y1="100" x2="90" y2="100" />
                        <line x1="30" y1="110" x2="90" y2="110" />
                        <line x1="30" y1="120" x2="90" y2="120" />
                        <line x1="30" y1="130" x2="90" y2="130" />
                        <line x1="30" y1="140" x2="90" y2="140" />
                        <line x1="30" y1="150" x2="90" y2="150" />
                        <line x1="30" y1="160" x2="90" y2="160" />
                        <line x1="30" y1="170" x2="90" y2="170" />
                        <line x1="30" y1="180" x2="90" y2="180" />
                    </g>
                    <g stroke="currentColor" stroke-width=".7" fill="none">
                        <rect x="90" y="30" width="160" height="60" />
                        <line x1="105" y1="30" x2="105" y2="90" />
                        <line x1="120" y1="30" x2="120" y2="90" />
                        <line x1="135" y1="30" x2="135" y2="90" />
                        <line x1="150" y1="30" x2="150" y2="90" />
                        <line x1="165" y1="30" x2="165" y2="90" />
                        <line x1="180" y1="30" x2="180" y2="90" />
                        <line x1="195" y1="30" x2="195" y2="90" />
                        <line x1="210" y1="30" x2="210" y2="90" />
                        <line x1="225" y1="30" x2="225" y2="90" />
                        <line x1="240" y1="30" x2="240" y2="90" />
                    </g>
                    <g stroke="currentColor" stroke-width=".9" fill="currentColor">
                        <line x1="60" y1="190" x2="60" y2="100" />
                        <path d="M60 95 L57 102 L63 102 Z" />
                        <circle cx="60" cy="190" r="2" fill="currentColor" />
                    </g>
                    <text x="68" y="146" rtElem="dim-text" font-family="JetBrains Mono" font-size="6" i18n="@@homeTypeArrowUp">
                        ↑ ВВЕРХ
                    </text>
                    <g stroke="currentColor" stroke-width=".9" fill="currentColor">
                        <line x1="105" y1="60" x2="245" y2="60" />
                        <path d="M250 60 L243 57 L243 63 Z" />
                    </g>
                    <text x="35" y="178" rtElem="dim-text" font-family="JetBrains Mono" font-size="5">1</text>
                    <text x="35" y="38" rtElem="dim-text" font-family="JetBrains Mono" font-size="5">9</text>
                    <text x="100" y="84" rtElem="dim-text" font-family="JetBrains Mono" font-size="5">10</text>
                    <text x="240" y="84" rtElem="dim-text" font-family="JetBrains Mono" font-size="5">18</text>
                    <g rtElem="dim" font-family="JetBrains Mono" font-size="6">
                        <line x1="20" y1="210" x2="260" y2="210" />
                        <line x1="20" y1="207" x2="20" y2="213" />
                        <line x1="260" y1="207" x2="260" y2="213" />
                        <text x="140" y="218" text-anchor="middle">2 400 мм</text>
                    </g>
                    <g rtElem="dim" font-family="JetBrains Mono" font-size="6">
                        <line x1="270" y1="20" x2="270" y2="200" />
                        <line x1="267" y1="20" x2="273" y2="20" />
                        <line x1="267" y1="200" x2="273" y2="200" />
                        <text x="277" y="113" transform="rotate(-90 277 113)" text-anchor="middle">1 800</text>
                    </g>
                </svg>
                <ng-container meta-rows>
                    <div>
                        <span i18n="@@homeTypeMetaSteps">ступеней</span>
                        <b>18</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaFlights">марша</span>
                        <b>2 × 9</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaLanding">площадка</span>
                        <b>900</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaTurn">поворот</span>
                        <b>90°</b>
                    </div>
                </ng-container>
            </sc-home-type-card>

            <sc-home-type-card
                link="/calc/u"
                num="03 · п-образная"
                i18n-num="@@homeTypeNumU"
                specs="2 марша · 180°"
                i18n-specs="@@homeTypeSpecsU"
                proj="plan · 1:50"
                i18n-proj="@@homeTypeProjPlan50"
                axis="план · вид сверху"
                i18n-axis="@@homeTypeAxisPlan"
                caption="П-образная"
                i18n-caption="@@homeTypeTitleU"
                desc="Разворот на 180° через широкую площадку. Самая компактная в плане, но требует на 30% больше древесины."
                i18n-desc="@@homeTypeDescU">
                <svg rtElem="sketch-svg" viewBox="0 0 280 224" preserveAspectRatio="xMidYMid meet">
                    <defs>
                        <pattern id="hatch3" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                            <line x1="0" y1="0" x2="0" y2="4" stroke="currentColor" stroke-width=".3" />
                        </pattern>
                    </defs>
                    <rect x="20" y="20" width="240" height="180" fill="none" stroke="currentColor" stroke-width="1.4" />
                    <rect
                        x="24"
                        y="24"
                        width="232"
                        height="172"
                        fill="none"
                        stroke="currentColor"
                        stroke-width=".3"
                        stroke-dasharray="1 2" />
                    <rect x="40" y="40" width="200" height="50" fill="url(#hatch3)" stroke="currentColor" stroke-width=".8" />
                    <text
                        x="140"
                        y="64"
                        font-family="JetBrains Mono"
                        font-size="7"
                        text-anchor="middle"
                        fill="currentColor"
                        i18n="@@homeTypeLandingLabel">
                        площадка
                    </text>
                    <text x="140" y="74" rtElem="dim-text" font-family="JetBrains Mono" font-size="6" text-anchor="middle">2400×1000</text>
                    <g stroke="currentColor" stroke-width=".7" fill="none">
                        <rect x="40" y="90" width="50" height="90" />
                        <line x1="40" y1="100" x2="90" y2="100" />
                        <line x1="40" y1="110" x2="90" y2="110" />
                        <line x1="40" y1="120" x2="90" y2="120" />
                        <line x1="40" y1="130" x2="90" y2="130" />
                        <line x1="40" y1="140" x2="90" y2="140" />
                        <line x1="40" y1="150" x2="90" y2="150" />
                        <line x1="40" y1="160" x2="90" y2="160" />
                        <line x1="40" y1="170" x2="90" y2="170" />
                    </g>
                    <g stroke="currentColor" stroke-width=".7" fill="none">
                        <rect x="190" y="90" width="50" height="90" />
                        <line x1="190" y1="100" x2="240" y2="100" />
                        <line x1="190" y1="110" x2="240" y2="110" />
                        <line x1="190" y1="120" x2="240" y2="120" />
                        <line x1="190" y1="130" x2="240" y2="130" />
                        <line x1="190" y1="140" x2="240" y2="140" />
                        <line x1="190" y1="150" x2="240" y2="150" />
                        <line x1="190" y1="160" x2="240" y2="160" />
                        <line x1="190" y1="170" x2="240" y2="170" />
                    </g>
                    <g stroke="currentColor" stroke-width=".9" fill="currentColor">
                        <circle cx="65" cy="175" r="2" />
                        <line x1="65" y1="175" x2="65" y2="100" />
                        <path d="M65 95 L62 102 L68 102 Z" />
                        <line x1="65" y1="65" x2="215" y2="65" />
                        <line x1="215" y1="65" x2="215" y2="170" />
                        <path d="M215 175 L212 168 L218 168 Z" />
                    </g>
                    <text x="48" y="135" rtElem="dim-text" font-family="JetBrains Mono" font-size="5" transform="rotate(-90 48 135)">
                        ↑ FLIGHT 1
                    </text>
                    <text x="244" y="135" rtElem="dim-text" font-family="JetBrains Mono" font-size="5" transform="rotate(-90 244 135)">
                        FLIGHT 2 ↓
                    </text>
                    <text x="42" y="178" rtElem="dim-text" font-family="JetBrains Mono" font-size="5">1</text>
                    <text x="42" y="100" rtElem="dim-text" font-family="JetBrains Mono" font-size="5">9</text>
                    <text x="220" y="100" rtElem="dim-text" font-family="JetBrains Mono" font-size="5">10</text>
                    <text x="220" y="178" rtElem="dim-text" font-family="JetBrains Mono" font-size="5">18</text>
                    <g rtElem="dim" font-family="JetBrains Mono" font-size="6">
                        <line x1="20" y1="210" x2="260" y2="210" />
                        <line x1="20" y1="207" x2="20" y2="213" />
                        <line x1="260" y1="207" x2="260" y2="213" />
                        <text x="140" y="218" text-anchor="middle">2 400 мм</text>
                    </g>
                    <g rtElem="dim" font-family="JetBrains Mono" font-size="6">
                        <line x1="270" y1="20" x2="270" y2="200" />
                        <line x1="267" y1="20" x2="273" y2="20" />
                        <line x1="267" y1="200" x2="273" y2="200" />
                        <text x="277" y="113" transform="rotate(-90 277 113)" text-anchor="middle">1 800</text>
                    </g>
                </svg>
                <ng-container meta-rows>
                    <div>
                        <span i18n="@@homeTypeMetaSteps">ступеней</span>
                        <b>18</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaFlights">марша</span>
                        <b>2 × 9</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaLanding">площадка</span>
                        <b>2000×1000</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaTurn">поворот</span>
                        <b>180°</b>
                    </div>
                </ng-container>
            </sc-home-type-card>

            <sc-home-type-card
                link="/calc/spiral"
                num="04 · винтовая"
                i18n-num="@@homeTypeNumSpiral"
                specs="Ø 1600 · 12 ст."
                i18n-specs="@@homeTypeSpecsSpiral"
                proj="plan · 1:30"
                i18n-proj="@@homeTypeProjPlan30"
                axis="план · вид сверху"
                i18n-axis="@@homeTypeAxisPlan"
                caption="Винтовая"
                i18n-caption="@@homeTypeTitleSpiral"
                desc="12 забежных ступеней вокруг центральной стойки. Минимальная площадь в плане — от 1.5 м². Сложнее в монтаже и менее удобна в эксплуатации."
                i18n-desc="@@homeTypeDescSpiral">
                <svg rtElem="sketch-svg" viewBox="0 0 280 224" preserveAspectRatio="xMidYMid meet">
                    <defs>
                        <pattern id="hatch4" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                            <line x1="0" y1="0" x2="0" y2="4" stroke="currentColor" stroke-width=".3" />
                        </pattern>
                    </defs>
                    <circle cx="140" cy="110" r="92" fill="none" stroke="currentColor" stroke-width=".3" stroke-dasharray="2 2" />
                    <circle cx="140" cy="110" r="80" fill="none" stroke="currentColor" stroke-width="1" />
                    <g stroke="currentColor" stroke-width=".7" fill="none">
                        <line x1="140" y1="30" x2="140" y2="110" />
                        <line x1="209.3" y1="70" x2="140" y2="110" />
                        <line x1="209.3" y1="150" x2="140" y2="110" />
                        <line x1="140" y1="190" x2="140" y2="110" />
                        <line x1="70.7" y1="150" x2="140" y2="110" />
                        <line x1="70.7" y1="70" x2="140" y2="110" />
                        <line x1="174.6" y1="40.7" x2="140" y2="110" />
                        <line x1="220" y1="110" x2="140" y2="110" />
                        <line x1="174.6" y1="179.3" x2="140" y2="110" />
                        <line x1="105.4" y1="179.3" x2="140" y2="110" />
                        <line x1="60" y1="110" x2="140" y2="110" />
                        <line x1="105.4" y1="40.7" x2="140" y2="110" />
                    </g>
                    <circle cx="140" cy="110" r="14" fill="url(#hatch4)" stroke="currentColor" stroke-width="1" />
                    <circle cx="140" cy="110" r="4" fill="currentColor" />
                    <g rtElem="dim-text" font-family="JetBrains Mono" font-size="6" text-anchor="middle">
                        <text x="160" y="48">1</text>
                        <text x="190" y="68">2</text>
                        <text x="206" y="98">3</text>
                        <text x="206" y="128">4</text>
                        <text x="190" y="158">5</text>
                        <text x="160" y="178">6</text>
                        <text x="120" y="178">7</text>
                        <text x="90" y="158">8</text>
                        <text x="74" y="128">9</text>
                        <text x="74" y="98">10</text>
                        <text x="90" y="68">11</text>
                        <text x="120" y="48">12</text>
                    </g>
                    <g stroke="currentColor" stroke-width=".8" fill="currentColor">
                        <path d="M178 30 A88 88 0 0 1 220 80" fill="none" />
                        <path d="M222 78 L226 84 L218 86 Z" />
                    </g>
                    <circle cx="140" cy="190" r="3" fill="currentColor" />
                    <text x="146" y="200" font-family="JetBrains Mono" font-size="6" fill="currentColor" i18n="@@homeTypeEntryLabel">
                        вход
                    </text>
                    <g rtElem="dim" font-family="JetBrains Mono" font-size="6">
                        <line x1="60" y1="210" x2="220" y2="210" />
                        <line x1="60" y1="207" x2="60" y2="213" />
                        <line x1="220" y1="207" x2="220" y2="213" />
                        <text x="140" y="218" text-anchor="middle" i18n="@@homeTypeDimDiameter">⌀ 1 600 мм</text>
                    </g>
                    <g rtElem="dim" font-family="JetBrains Mono" font-size="5">
                        <line x1="140" y1="96" x2="156" y2="80" />
                        <text x="158" y="78">⌀ 280</text>
                    </g>
                    <text x="140" y="22" rtElem="dim-text" font-family="JetBrains Mono" font-size="6" text-anchor="middle">N</text>
                </svg>
                <ng-container meta-rows>
                    <div>
                        <span i18n="@@homeTypeMetaSteps">ступеней</span>
                        <b i18n="@@homeTypeMetaSpiralStepsValue">12 / об.</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaDiamOuter">⌀ внеш.</span>
                        <b>1600</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaDiamColumn">⌀ стойка</span>
                        <b>280</b>
                    </div>
                    <div>
                        <span i18n="@@homeTypeMetaSector">сектор</span>
                        <b>30°</b>
                    </div>
                </ng-container>
            </sc-home-type-card>
        </div>
    </section>

    <section rtElem="specs">
        <div rtElem="grid-4">
            <div>
                <h4 rtElem="spec-h4" i18n="@@homeSpecNormTitle">Норматив</h4>
                <p rtElem="spec-p" i18n="@@homeSpecNormBody">
                    Формула Блонделя и СП 54.13330.2022 (бывший СНиП 2.08.01-89) — применяются к каждому расчёту автоматически.
                </p>
            </div>
            <div>
                <h4 rtElem="spec-h4" i18n="@@homeSpecMatTitle">Материалы</h4>
                <p rtElem="spec-p" i18n="@@homeSpecMatBody">Дуб, ясень, бук, берёза, сосна, лиственница — с плотностью каждой породы.</p>
            </div>
            <div>
                <h4 rtElem="spec-h4" i18n="@@homeSpecExportTitle">Экспорт</h4>
                <p rtElem="spec-p" i18n="@@homeSpecExportBody">
                    JSON с конфигурацией и PNG 2D-плана — одной кнопкой, чертёж DXF для CAD — второй.
                </p>
            </div>
            <div>
                <h4 rtElem="spec-h4" i18n="@@homeSpecPrivTitle">Приватность</h4>
                <p rtElem="spec-p" i18n="@@homeSpecPrivBody">
                    Расчёт и 3D-рендер полностью на клиенте. Ни один параметр не уходит на сервер.
                </p>
            </div>
        </div>
    </section>

    <section rtElem="flow">
        <div rtElem="flow-head">
            <h2 rtElem="flow-h2">
                <span i18n="@@homeFlowHeadA">От размеров</span>
                &ngsp;
                <em i18n="@@homeFlowHeadEm">к расчёту</em>
                <span>.</span>
            </h2>
            <p rtElem="flow-lede" i18n="@@homeFlowLede">
                Пайплайн одинаковый для всех типов лестниц. Шаги не блокируют друг друга — все параметры живут в одной сцене, меняете любой
                и смотрите последствия.
            </p>
        </div>
        <div rtElem="grid-4">
            <div>
                <span rtElem="flow-num">01</span>
                <h3 rtElem="flow-step-h4" i18n="@@homeFlowStep1Title">Помещение</h3>
                <p rtElem="flow-step-p" i18n="@@homeFlowStep1Body">Длина, ширина, высота, толщина перекрытия, положение проёма.</p>
            </div>
            <div>
                <span rtElem="flow-num">02</span>
                <h3 rtElem="flow-step-h4" i18n="@@homeFlowStep2Title">Геометрия</h3>
                <p rtElem="flow-step-p" i18n="@@homeFlowStep2Body">Количество ступеней, высота подъёма, ширина проступи, угол наклона.</p>
            </div>
            <div>
                <span rtElem="flow-num">03</span>
                <h3 rtElem="flow-step-h4" i18n="@@homeFlowStep3Title">Материалы</h3>
                <p rtElem="flow-step-p" i18n="@@homeFlowStep3Body">Порода дерева, сечение тетивы, толщина проступи, перила и балясины.</p>
            </div>
            <div>
                <span rtElem="flow-num">04</span>
                <h3 rtElem="flow-step-h4" i18n="@@homeFlowStep4Title">Экспорт</h3>
                <p rtElem="flow-step-p" i18n="@@homeFlowStep4Body">JSON, PNG и DXF для CAD. Конфигурация сохраняется в URL.</p>
            </div>
        </div>
    </section>

    <section rtElem="std">
        <div>
            <h3 rtElem="std-h3" i18n="@@homeStdTitle">Нормы, зашитые в расчёт</h3>
            <p rtElem="std-p" i18n="@@homeStdLede">
                GoldenCalc валидирует каждую геометрию по российским и белорусским стандартам удобства и безопасности. Если параметры
                выходят за пределы — получите предупреждение ещё до экспорта.
            </p>
        </div>
        <div rtElem="std-r">
            <div rtElem="std-cell">
                <span rtElem="std-tag" i18n="@@homeStdBlondelTag">Формула Блонделя</span>
                <div rtElem="std-formula">2h + b = 600–650</div>
                <p rtElem="std-cell-p" i18n="@@homeStdBlondelBody">
                    Сумма удвоенной высоты подступёнка и ширины проступи — мера удобного шага.
                </p>
            </div>
            <div rtElem="std-cell">
                <span rtElem="std-tag" i18n="@@homeStdAngleTag">Угол наклона</span>
                <div rtElem="std-formula">26° — 45°</div>
                <p rtElem="std-cell-p" i18n="@@homeStdAngleBody">Оптимум для жилых помещений. До 60° — допустимо для чердачных.</p>
            </div>
            <div rtElem="std-cell">
                <span rtElem="std-tag" i18n="@@homeStdWidthTag">Ширина марша</span>
                <div rtElem="std-formula">≥ 900 мм</div>
                <p rtElem="std-cell-p" i18n="@@homeStdWidthBody">
                    Нижняя граница по СП 54.13330 для жилых зданий. Рекомендуемая — 1 000 мм.
                </p>
            </div>
        </div>
    </section>

    @if (blogArticles().length > 0) {
        <section rtElem="blog" aria-labelledby="home-blog-title">
            <div rtElem="blog-head">
                <h2 rtElem="blog-h2" id="home-blog-title">
                    <span i18n="@@homeBlogH2A">Из</span>
                    <em i18n="@@homeBlogH2Em">&nbsp;справочника</em>
                </h2>
                <a rtElem="blog-all" routerLink="/blog" qa-dataid="home-blog-all" i18n="@@homeBlogAll">Все статьи →</a>
            </div>
            <sc-card-carousel
                qa-dataid="home-blog-carousel"
                i18n-prevAriaLabel="@@homeBlogPrev"
                prevAriaLabel="Предыдущие статьи"
                i18n-nextAriaLabel="@@homeBlogNext"
                nextAriaLabel="Следующие статьи"
                [items]="blogCards()"
                [itemTemplate]="blogCardTpl" />
        </section>
    }

    <ng-template #blogCardTpl let-card>
        <sc-blog-article-card
            [slug]="card.article.slug"
            [path]="card.article.path"
            [groupLabel]="card.rubric"
            [title]="card.article.title"
            [description]="card.article.description"
            [imageSrc]="card.article.imageSrc"
            [imageSrcset]="card.article.imageSrcset" />
    </ng-template>

    <sc-contact-form [contextData]="lastStairConfig()" />

    <section rtElem="cta">
        <h2 rtElem="cta-h2">
            <span i18n="@@homeCtaH2A">Начните</span>
            &ngsp;
            <em i18n="@@homeCtaH2Em">с размеров —</em>
            <br />
            <span i18n="@@homeCtaH2B">расчёт появится сам.</span>
        </h2>
        <a rtElem="btn" routerLink="/calc/straight" i18n="@@homeCtaH2Button">Открыть конструктор →</a>
    </section>
</ng-container>
